/**
 * Single source of truth for stock-score rendering.
 *
 * Before this util, score appeared as `5.95` in ResultsTable but `6.0`
 * in Favorites (toFixed(1) rounding 5.95 -> 6.0) and `5.95` raw in
 * Charts grid. BUG-15 fix 2026-05-09: unify on toFixed(2) so the same
 * ticker reads identically across surfaces, and strip a trailing
 * `.00` so integers stay clean (`6` not `6.00`).
 */
export function formatScore(score: number | null | undefined, fallback: string = '-'): string {
  if (score === null || score === undefined) return fallback;
  const n = Number(score);
  if (!Number.isFinite(n)) return fallback;
  const fixed = n.toFixed(2);
  // Strip trailing zeros for integer scores: 6.00 -> 6, 5.50 -> 5.5
  return fixed.replace(/\.?0+$/, '') || '0';
}
